// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./assets/fonts/OpenSans/OpenSansRegular.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./assets/fonts/OpenSans/OpenSansRegular.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./assets/fonts/OpenSans/OpenSansRegular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("./assets/fonts/OpenSans/OpenSansSemiBold.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("./assets/fonts/OpenSans/OpenSansSemiBold.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("./assets/fonts/OpenSans/OpenSansSemiBold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("./assets/fonts/OpenSans/OpenSansBold.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("./assets/fonts/OpenSans/OpenSansBold.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("./assets/fonts/OpenSans/OpenSansBold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("./assets/icons/hidden-eye.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "Open Sans";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("truetype");
  font-weight: normal;
  font-style: normal;
}
@font-face {
  font-family: "Open Sans Semi Bold";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_6___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_7___}) format("truetype");
  font-weight: normal;
  font-style: normal;
}
@font-face {
  font-family: "Open Sans Bold";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_9___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_10___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_11___}) format("truetype");
  font-weight: normal;
  font-style: normal;
}
@media (max-width: 415px) {
  .hidden-eye.password {
    display: none;
  }
}
@media (min-width: 415px) {
  .hidden-eye.password {
    display: flex;
  }
}
@media (max-width: 415px) {
  .hidden-eye.mobile-password {
    display: flex;
  }
}
@media (min-width: 415px) {
  .hidden-eye.mobile-password {
    display: none;
  }
}
.hidden-eye:before {
  cursor: pointer;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_12___});
  content: "";
  position: absolute;
  width: 25px;
  height: 15px;
  margin-top: -36px;
  right: 10px;
  margin-left: 328px;
  background-repeat: no-repeat;
}

.hidden-input {
  display: none;
}

.alert {
  font-size: 10px !important;
  position: absolute;
  margin: 55px 0 0 5px;
  font-family: "Open Sans";
  font-style: normal;
  font-size: 12px;
  line-height: 140%;
  color: #df5959 !important;
}
@media (max-width: 415px) {
  .alert {
    margin: 55px 0 0 5%;
  }
}

.outline_red {
  border: 1px solid red !important;
}

.outline_regular {
  border: 1px solid black !important;
}

.active_header {
  color: #919ca7 !important;
}

::-webkit-scrollbar {
  display: none;
}

.item {
  align-items: center;
  cursor: pointer;
  display: flex;
  font-size: 14px;
  height: 40px;
  font-family: "Open Sans";
  font-style: normal;
  font-size: 14px;
  line-height: 130%;
  display: flex;
  align-items: center;
  text-align: center;
  color: #333333;
  justify-content: center;
  width: 40px;
  border-radius: 40px;
  border: 1px solid #e3e8ef;
}

.disabled-page {
  color: #333333;
}

.active {
  background: #49a3a6;
  border-radius: 40px;
  color: #ffffff;
}

.next {
  font-size: 4px;
  height: 60px;
  position: absolute;
  right: 0;
  border: none !important;
  padding-right: 25px;
}

.pagination {
  align-items: center;
  display: flex;
  padding-left: 16px;
  flex-direction: row;
  gap: 15px;
  height: 60px;
  margin-bottom: -12px;
  justify-content: left;
  list-style-type: none;
  position: relative;
}

.pagination-page {
  font-weight: 700;
}

.previous {
  font-size: 4px;
  height: 60px;
  right: 40px;
  border: none !important;
  position: absolute;
}

.error-input {
  border: 1px solid red !important;
}

.no-data {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 49vh;
  font-family: "Open Sans Semi Bold";
  font-style: normal;
  font-size: 12px;
  line-height: 140%;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: #b3b8bf;
}

.lds-dual-ring {
  display: inline-block;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
}

.lds-dual-ring:after {
  content: " ";
  display: block;
  width: 64px;
  height: 64px;
  margin: 8px;
  border-radius: 50%;
  border: 6px solid red;
  border-color: #b2b8bf transparent #b2b8bf transparent;
  animation: lds-dual-ring 1.2s linear infinite;
}

@keyframes lds-dual-ring {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.hidden-eye {
  background: red !important;
  margin-top: -5px !important;
  z-index: 99999;
  display: flex;
}

.rating_container {
  display: flex !important;
}

.no_data_mini {
  font-family: "Open Sans" !important;
  font-style: normal !important;
  font-size: 12px !important;
  margin-top: 10px !important;
  line-height: 140% !important;
  color: #919ca7 !important;
}

.login-form.Mui-focused {
  border: solid 1px #333333 !important;
}

.invalid .login-form.Mui-focused {
  border: solid 1px #df5959 !important;
}

.form-dialog .MuiDialog-paper {
  border-radius: 10px;
}

.select > div {
  margin: 0;
}
.select .input button {
  padding: 0 43px 0 0;
  gap: 10px;
}
.select .input button > div:first-child {
  margin-right: 0;
}
.select .input.Mui-focused > div::before {
  background-color: #49a3a6;
}
.select .input.Mui-focused fieldset {
  border: 1px solid #49a3a6 !important;
  box-shadow: 0px 0px 9px rgba(41, 97, 99, 0.2) !important;
}`, "",{"version":3,"sources":["webpack://./src/global.scss"],"names":[],"mappings":"AAAA;EACE,wBAAA;EACA,4CAAA;EACA,4LAAA;EAIA,mBAAA;EACA,kBAAA;AAFF;AAKA;EACE,kCAAA;EACA,4CAAA;EACA,4LAAA;EAIA,mBAAA;EACA,kBAAA;AANF;AASA;EACE,6BAAA;EACA,4CAAA;EACA,8LAAA;EAGA,mBAAA;EACA,kBAAA;AATF;AAcI;EADF;IAEI,aAAA;EAXJ;AACF;AAaI;EALF;IAMI,aAAA;EAVJ;AACF;AAcI;EADF;IAEI,aAAA;EAXJ;AACF;AAaI;EALF;IAMI,aAAA;EAVJ;AACF;AAaE;EACE,eAAA;EACA,oDAAA;EACA,WAAA;EACA,kBAAA;EAGA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,WAAA;EACA,kBAAA;EACA,4BAAA;AAbJ;;AAiBA;EACE,aAAA;AAdF;;AAiBA;EAKE,0BAAA;EACA,kBAAA;EACA,oBAAA;EACA,wBAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,yBAAA;AAlBF;AAOE;EADF;IAEI,mBAAA;EAJF;AACF;;AAgBA;EACE,gCAAA;AAbF;;AAgBA;EACE,kCAAA;AAbF;;AAgBA;EACE,yBAAA;AAbF;;AAgBA;EACE,aAAA;AAbF;;AAgBA;EACE,mBAAA;EACA,eAAA;EACA,aAAA;EACA,eAAA;EACA,YAAA;EACA,wBAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,cAAA;EACA,uBAAA;EACA,WAAA;EACA,mBAAA;EACA,yBAAA;AAbF;;AAgBA;EACE,cAAA;AAbF;;AAgBA;EACE,mBAAA;EACA,mBAAA;EACA,cAAA;AAbF;;AAgBA;EACE,cAAA;EACA,YAAA;EACA,kBAAA;EACA,QAAA;EACA,uBAAA;EACA,mBAAA;AAbF;;AAgBA;EACE,mBAAA;EACA,aAAA;EACA,kBAAA;EACA,mBAAA;EACA,SAAA;EACA,YAAA;EACA,oBAAA;EACA,qBAAA;EACA,qBAAA;EACA,kBAAA;AAbF;;AAgBA;EACE,gBAAA;AAbF;;AAgBA;EACE,cAAA;EACA,YAAA;EACA,WAAA;EACA,uBAAA;EACA,kBAAA;AAbF;;AAiBA;EACE,gCAAA;AAdF;;AAiBA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,kCAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,yBAAA;EACA,cAAA;AAdF;;AAiBA;EACE,qBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;AAdF;;AAgBA;EACE,YAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,qBAAA;EACA,qDAAA;EACA,6CAAA;AAbF;;AAeA;EACE;IACE,uBAAA;EAZF;EAcA;IACE,yBAAA;EAZF;AACF;AAeA;EACE,0BAAA;EACA,2BAAA;EACA,cAAA;EACA,aAAA;AAbF;;AAgBA;EACE,wBAAA;AAbF;;AAgBA;EACE,mCAAA;EACA,6BAAA;EACA,0BAAA;EACA,2BAAA;EACA,4BAAA;EACA,yBAAA;AAbF;;AAgBA;EACE,oCAAA;AAbF;;AAiBE;EACE,oCAAA;AAdJ;;AAmBE;EACE,mBAAA;AAhBJ;;AAqBE;EACE,SAAA;AAlBJ;AAqBI;EACE,mBAAA;EACA,SAAA;AAnBN;AAqBM;EACE,eAAA;AAnBR;AAwBM;EACE,yBAAA;AAtBR;AAyBM;EACE,oCAAA;EACA,wDAAA;AAvBR","sourcesContent":["@font-face {\n  font-family: 'Open Sans';\n  src: url('./assets/fonts/OpenSans/OpenSansRegular.eot');\n  src: url('./assets/fonts/OpenSans/OpenSansRegular.eot?#iefix')\n      format('embedded-opentype'),\n    url('./assets/fonts/OpenSans/OpenSansRegular.woff') format('woff'),\n    url('./assets/fonts/OpenSans/OpenSansRegular.ttf') format('truetype');\n  font-weight: normal;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: 'Open Sans Semi Bold';\n  src: url('./assets/fonts/OpenSans/OpenSansSemiBold.eot');\n  src: url('./assets/fonts/OpenSans/OpenSansSemiBold.eot?#iefix')\n      format('embedded-opentype'),\n    url('./assets/fonts/OpenSans/OpenSansSemiBold.woff') format('woff'),\n    url('./assets/fonts/OpenSans/OpenSansSemiBold.ttf') format('truetype');\n  font-weight: normal;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: 'Open Sans Bold';\n  src: url('./assets/fonts/OpenSans/OpenSansBold.eot');\n  src: url('./assets/fonts/OpenSans/OpenSansBold.eot?#iefix') format('embedded-opentype'),\n    url('./assets/fonts/OpenSans/OpenSansBold.woff') format('woff'),\n    url('./assets/fonts/OpenSans/OpenSansBold.ttf') format('truetype');\n  font-weight: normal;\n  font-style: normal;\n}\n\n.hidden-eye {\n  &.password {\n    @media (max-width: 415px) {\n      display: none;\n    }\n\n    @media (min-width: 415px) {\n      display: flex;\n    }\n  }\n\n  &.mobile-password {\n    @media (max-width: 415px) {\n      display: flex;\n    }\n\n    @media (min-width: 415px) {\n      display: none;\n    }\n  }\n\n  &:before {\n    cursor: pointer;\n    background: url('./assets/icons/hidden-eye.svg');\n    content: '';\n    position: absolute;\n    //left: 0px;\n    //top: -15px;\n    width: 25px;\n    height: 15px;\n    margin-top: -36px;\n    right: 10px;\n    margin-left: 328px;\n    background-repeat: no-repeat;\n  }\n}\n\n.hidden-input {\n  display: none;\n}\n\n.alert {\n  @media (max-width: 415px) {\n    margin: 55px 0 0 5%;\n  }\n\n  font-size: 10px !important;\n  position: absolute;\n  margin: 55px 0 0 5px;\n  font-family: 'Open Sans';\n  font-style: normal;\n  font-size: 12px;\n  line-height: 140%;\n  color: #df5959 !important;\n}\n\n.outline_red {\n  border: 1px solid red !important;\n}\n\n.outline_regular {\n  border: 1px solid black !important;\n}\n\n.active_header {\n  color: #919ca7 !important;\n}\n\n::-webkit-scrollbar {\n  display: none;\n}\n\n.item {\n  align-items: center;\n  cursor: pointer;\n  display: flex;\n  font-size: 14px;\n  height: 40px;\n  font-family: 'Open Sans';\n  font-style: normal;\n  font-size: 14px;\n  line-height: 130%;\n  display: flex;\n  align-items: center;\n  text-align: center;\n  color: #333333;\n  justify-content: center;\n  width: 40px;\n  border-radius: 40px;\n  border: 1px solid #e3e8ef;\n}\n\n.disabled-page {\n  color: #333333;\n}\n\n.active {\n  background: #49a3a6;\n  border-radius: 40px;\n  color: #ffffff;\n}\n\n.next {\n  font-size: 4px;\n  height: 60px;\n  position: absolute;\n  right: 0;\n  border: none !important;\n  padding-right: 25px;\n}\n\n.pagination {\n  align-items: center;\n  display: flex;\n  padding-left: 16px;\n  flex-direction: row;\n  gap: 15px;\n  height: 60px;\n  margin-bottom: -12px;\n  justify-content: left;\n  list-style-type: none;\n  position: relative;\n}\n\n.pagination-page {\n  font-weight: 700;\n}\n\n.previous {\n  font-size: 4px;\n  height: 60px;\n  right: 40px;\n  border: none !important;\n  position: absolute;\n  //width: 150px;\n}\n\n.error-input {\n  border: 1px solid red !important;\n}\n\n.no-data {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: 49vh;\n  font-family: 'Open Sans Semi Bold';\n  font-style: normal;\n  font-size: 12px;\n  line-height: 140%;\n  letter-spacing: 0.05em;\n  text-transform: uppercase;\n  color: #b3b8bf;\n}\n\n.lds-dual-ring {\n  display: inline-block;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n}\n.lds-dual-ring:after {\n  content: ' ';\n  display: block;\n  width: 64px;\n  height: 64px;\n  margin: 8px;\n  border-radius: 50%;\n  border: 6px solid red;\n  border-color: #b2b8bf transparent #b2b8bf transparent;\n  animation: lds-dual-ring 1.2s linear infinite;\n}\n@keyframes lds-dual-ring {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n.hidden-eye {\n  background: red !important;\n  margin-top: -5px !important;\n  z-index: 99999;\n  display: flex;\n}\n\n.rating_container {\n  display: flex !important;\n}\n\n.no_data_mini {\n  font-family: 'Open Sans' !important;\n  font-style: normal !important;\n  font-size: 12px !important;\n  margin-top: 10px !important;\n  line-height: 140% !important;\n  color: #919ca7 !important;\n}\n\n.login-form.Mui-focused {\n  border: solid 1px #333333 !important;\n}\n\n.invalid {\n  .login-form.Mui-focused {\n    border: solid 1px #df5959 !important;\n  }\n}\n\n.form-dialog {\n  .MuiDialog-paper {\n    border-radius: 10px;\n  }\n}\n\n.select {\n  > div {\n    margin: 0;\n  }\n  .input {\n    button {\n      padding: 0 43px 0 0;\n      gap: 10px;\n\n      > div:first-child {\n        margin-right: 0;\n      }\n    }\n\n    &.Mui-focused {\n      > div::before {\n        background-color: #49a3a6;\n      }\n\n      fieldset {\n        border: 1px solid #49a3a6 !important;\n        box-shadow: 0px 0px 9px rgba(41, 97, 99, 0.2) !important;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
